namespace TabAurous.Retail {
    export namespace POSSalesReportService {
        export const baseUrl = 'Retail/POSSalesReport';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSSalesReport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSSalesReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
